import type { VfConfig } from '#types/config/components/vf'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    floatingNavigation: 'flex center p-1 ease-out duration lg:(grid cols-[1fr_auto_1fr] w-full px-3 py-2) <lg:(gap-5 b rounded-$rounded bg-brand-2 op-$op shadow-$shadow backdrop-blur)',
    floatingNavigationExpanded: 'grow',
    header: 'b-b b-grey-70',
    iconWrapper: 'lg:gap-3',
    logo: 'h-6',
    totalItems: 'top-0 bg-brand-3 fw-bold !text-xs',
    utilityNavigation: 'gap-4 pb-2 pt-4'
  },
  cartIconSize: 'md',
  excludeStickyRoute: (() => []) as unknown as string[],
  floatingNavigation: false,
  showMenuIndicator: true,
  showOnScrollUp: true
} satisfies RecursivePartial<VfConfig['header']>
